import axios from 'axios';
import config from 'configs';
import { getHeaderAuthorization } from 'helpers/cognito.lib';

class API {

  /**
   * Fetch user info
   */
  static async fetchUserInfo() {
    return axios({
      method: 'get',
      baseURL: config.api.API.BASE,
      url: config.api.API.FETCH_USER_INFO,
      headers: await getHeaderAuthorization(),
      params: {}
    });
  }
}

export default API;